import styles from "./NotFound.module.scss";
import MainButton from "../../components/shared/MainButton/MainButton";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div id={styles.not_found_page}>
      <div className={styles.not_found_image}>
        <div className={styles.content}>
          <h1 className={styles.err_status}>404</h1>
          <p className={styles.oops}>Oops, Page Not Found :(</p>
          <div className={styles.not_found_btn}>
            <MainButton onClick={() => navigate("/")}>
              Go To Dashboard
            </MainButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
